/**
 * Capitalizes the first character of a string.
 * Returns empty string if passed parameter is not of type string.
 * @param {string} string
 */
export default function capitalize(string) {
    if (typeof string !== 'string') {
        return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
